export const getVehicleDetailsCta = {
    event: "get_vehicle_details_cta",
    eventAction: "reg_number_entered"
};
